<template>
  <img
    v-if="dataUrl"
    class="qr-code"
    :src="dataUrl"
    :width="size"
    :height="size"
    :alt="alt"
  >
</template>

<script setup>
import { ref, watch } from 'vue'
import QRCode from 'qrcode'

defineOptions({ name: 'QrCode' })
const props = defineProps({
  value: { type: String, required: true },
  size: { type: Number, default: 200 },
  alt: { type: String, default: 'QR code' }
})

const dataUrl = ref(null)

let requestId = 0
watch(() => props.value, async value => {
  const thisRequestId = ++requestId
  if (!value) {
    dataUrl.value = null
    return
  }
  try {
    const url = await QRCode.toDataURL(value, { width: props.size, margin: 1 })
    if (thisRequestId === requestId) dataUrl.value = url
  } catch {
    if (thisRequestId === requestId) dataUrl.value = null
  }
}, { immediate: true })
</script>

<style scoped>
@reference "#app-styles.css";

.qr-code {
  @apply rounded-md;
}
</style>
